<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#e5f175" type="square-jelly-box" [fullScreen]="true">
    <p style="color: #e5f175"> Iniciando Sesión... </p>
</ngx-spinner>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<notifier-container></notifier-container>

<div class="auth-wrapper d-flex justify-content-center align-items-center login-auth-bg">
    <div class="auth-box login-card">
        <div id="login" [ngClass]="{'d-none': recoverform}">
            <div class="login-card__header text-center">
                <span class="login-card__logo d-inline-flex align-items-center justify-content-center">
                    <img ngSrc="assets/images/big/mancheno.png" alt="Grupo Mancheno" height="138" width="138"
                        priority="" />
                </span>
                <!-- <span class="login-card__tag d-inline-flex align-items-center justify-content-center">
                    <i-feather name="shield"></i-feather>
                    Acceso seguro
                </span> -->
                <h2 class="login-card__title mb-0">Bienvenido</h2>
            </div>

            <div *ngIf="msg" class="alert alert-danger login-alert text-center">{{ msg }}</div>

            <form class="login-form" id="loginform" (ngSubmit)="loadDataUrl(uname, p, null, modalType)">
                <div class="mb-3">
                    <label class="form-label" for="login-user">Usuario</label>
                    <div class="input-group login-input-group">
                        <span class="input-group-text" id="basic-addon1">
                            <i-feather name="user"></i-feather>
                        </span>
                        <input id="login-user" type="text" class="form-control form-control-lg" maxlength="20"
                            placeholder="Usuario" aria-label="Usuario" aria-describedby="basic-addon1"
                            name='uname' [(ngModel)]="uname" appNoSpace autocomplete="username">
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label" for="login-password">Clave</label>
                    <div class="input-group login-input-group">
                        <span class="input-group-text" id="basic-addon2">
                            <i-feather name="lock"></i-feather>
                        </span>

                        <input id="login-password" [type]="showPassword ? 'text' : 'password'"
                            class="form-control form-control-lg" placeholder="Clave" maxlength="20"
                            aria-label="Clave" aria-describedby="basic-addon2" name="p" [(ngModel)]="p"
                            appNoSpace autocomplete="current-password">

                        <button class="btn login-password-toggle" type="button"
                            (click)="togglePasswordVisibility()" [attr.aria-label]="showPassword ? 'Ocultar clave' : 'Mostrar clave'">
                            <i-feather [name]="showPassword ? 'eye-off' : 'eye'"></i-feather>
                        </button>
                    </div>
                </div>

                <button class="btn btn-lg login-submit w-100" type="submit" [disabled]="isLoading || !uname || !p">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>
                    <span>{{ isLoading ? 'Ingresando...' : 'Iniciar sesión' }}</span>
                </button>

                <div class="login-card__footer text-center">
                    <span class="app-version-badge">{{ appVersion }}</span>
                </div>
            </form>
        </div>

        <div id="recoverform" [ngClass]="{'d-block': recoverform}">
            <div class="login-card__header text-center">
                <span class="login-card__logo d-inline-flex align-items-center justify-content-center">
                    <img src="assets/images/logos/xtreme-dark-icon.svg" alt="logo" />
                </span>
                <h5 class="font-medium mb-3">Recuperar contraseña</h5>
                <span>Ingresa tu usuario de acceso!</span>
            </div>
            <div class="row mt-3">
                <form class="col-12">
                    <div class="mb-3 row">
                        <div class="col-12">
                            <input class="form-control form-control-lg" type="email" required=""
                                placeholder="Username">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12">
                            <button class="btn d-block w-100 btn-lg btn-danger" type="submit"
                                name="action">Reset</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>


<ng-template #modalType let-modal>
    <div class="modal-header module-modal__header d-flex align-items-center gap-3">
        <div class="module-modal__title-wrap d-flex align-items-center gap-3 flex-grow-1">
            <span class="module-modal__title-icon">
                <i-feather name="grid"></i-feather>
            </span>
            <div>
                <h4 class="module-modal__title mb-0">Seleccionar Módulo</h4>
            </div>
        </div>
        <button type="button" class="btn-close module-modal__close" aria-label="Close" (click)="closeBtnClick()"></button>
    </div>

    <div class="modal-body module-modal__body">
        <div class="module-modal__empty" *ngIf="availableModules.length === 0">
            <i-feather name="alert-circle" class="module-modal__empty-icon"></i-feather>
            <p class="module-modal__empty-title mb-0">No hay módulos disponibles</p>
            <p class="module-modal__empty-subtitle mb-0">Contacta al administrador para habilitar accesos.</p>
        </div>

        <div *ngIf="availableModules.length > 0">
            <div class="module-grid">
                <button *ngFor="let module of availableModules" class="module-option" (click)="navigateToModule(module)">
                    <span class="module-option__icon">
                        <i-feather [name]="module.icono"></i-feather>
                    </span>
                    <span class="module-option__label">{{ module.nombre }}</span>
                    <span class="module-option__hint">Ingresar</span>
                </button>
            </div>
        </div>
    </div>

    <div class="modal-footer module-modal__footer justify-content-end">
        <button type="button" class="btn module-modal__close-btn" (click)="closeBtnClick()">Cerrar</button>
    </div>
</ng-template>
